// ✏️  Edita los textos entre comillas
// ➕  Para agregar una opción, copia un bloque { } y pégalo
// ⚠️  No elimines llaves { }, corchetes [ ] ni comas ,

export const TEMAS = {
  mensaje: '¿Qué deseas cambiar en la apariencia?',
  opciones: [
    {
      boton: 'Cambiar a modo oscuro',
      respuesta: 'Haz clic en el ícono de tema en el menú de usuario (esquina superior derecha) y selecciona el modo "Oscuro".',
    },
    {
      boton: 'Cambiar a modo claro',
      respuesta: 'Haz clic en el ícono de tema en el menú de usuario y selecciona el modo "Claro".',
    },
    {
      boton: 'Ver todos los temas disponibles',
      respuesta: 'El sistema cuenta con 5 temas: Claro, Oscuro, Azul (sky-blue), Verde alto contraste y Púrpura. Los encuentras en el selector de tema del menú de usuario.',
    },
  ],
}
